/* eslint-disable */
import React, { useState, useEffect } from "react";
import { FaAngleDoubleRight, FaArrowRight, FaCheckCircle } from "react-icons/fa";
import { Link } from "react-router-dom";

const AdvisoryArea = () => {
  const [showMeetings, setShowMeetings] = useState(false);

  useEffect(() => {
    if (!showMeetings) return;

    const existingScript = document.querySelector("script[data-hs-meetings]");

    if (!existingScript) {
      const s = document.createElement("script");
      s.type = "text/javascript";
      s.src =
        "https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js";
      s.setAttribute("data-hs-meetings", "true");
      s.onload = () => {
        if (window.HubSpotConversations) {
          window.HubSpotConversations.widget.refresh();
        }
      };
      document.body.appendChild(s);
    } else {
      setTimeout(() => {
        if (window.HubSpotConversations) {
          window.HubSpotConversations.widget.refresh();
        }
      }, 100);
    }
  }, [showMeetings]);

  // =========================
  // Fund Advisory Content
  // =========================
  const outcomes = [
    "A custom capital + funding strategy built around your business reality",
    "Hands-on execution support across grants, decks, docs, and financials",
    "Improved corporate structure, governance, and investor readiness",
    "A working investor pipeline + outreach workflow",
    "Clear GTM, monetization, and traction milestones aligned to capital goals",
  ];

  const forWho = [
    "Founders who have outgrown templates, webinars, and one-off advice",
    "Teams needing hands-on execution (not just a checklist)",
    "Companies preparing for major investor meetings or large grant milestones",
    "Innovation-focused ventures (AI, biotech, medtech, SaaS, robotics, cleantech)",
    "Leadership teams that want a trusted strategic + operational partner",
  ];

  const problem = [
    "Generic funding advice doesn’t fit your business model, sector, or stage",
    "Your team needs execution support, not just feedback",
    "Structural gaps (cap table, governance, IP, model) block funding momentum",
    "Grant readiness requires real narratives, budgets, and documentation",
    "Investor meetings demand a tight story, materials, and preparation",
  ];

  // Keep the 2-column deliverables layout, but map to the “What We Do Together”
  const deliverablesLeft = [
    "Custom multi-year funding & capital roadmap",
    "Hands-on implementation checklist + ongoing working sessions",
    "Advanced grant strategy + grant section drafting support",
    "Project budgets, timelines, and supporting documentation preparation",
    "Corporate structuring & capital architecture fixes (cap table modelling, scenarios)",
    "Investor narrative rebuild + one-page summary / teaser",
  ];

  const deliverablesRight = [
    "Investor pipeline research & prioritization (sector/stage matched)",
    "Outreach scripts + sequencing + follow-up frameworks",
    "Traction update email support + investor comms review",
    "Pitch coaching, Q&A prep, role-play for meetings",
    "GTM, pricing & monetization strategy support",
    "Partnership strategy frameworks and milestone planning",
  ];

  const whyChoose = [
    "Strategy + execution (we build with you, not just advise)",
    "High-touch, business-specific scope (no cookie-cutter deliverables)",
    "Faster funding readiness through hands-on work sessions",
    "Deep partner involvement across structure, story, grants, and outreach",
    "High ROI by avoiding missteps and upgrading readiness end-to-end",
  ];

  const optionalAddOns = [
    "Full grant writing and submission management",
    "Full pitch deck visual design",
    "Financial model design and build-out",
    "Investor introduction facilitation (case-by-case)",
    "SR&ED documentation + technical narrative support",
    "Monthly operational and strategy advisory",
    "AI & workflow automation planning for internal processes",
  ];

  const engagementModels = [
    "Project-Based: $7,500 – $40,000+ (complexity & duration dependent)",
    "Monthly Retainer: $2,000 – $6,000 / month (3–6 month minimum)",
    "Hybrid: Base fee + defined performance bonuses (ethical consulting incentives)",
  ];

  const notIncluded = [
    "We are not a fund, VC, or financial institution (no capital pooling/management)",
    "No guaranteed funding or grant approvals (outcomes can’t be promised)",
    "Legal/accounting delivery (we can introduce partners as needed)",
  ];

  const afterProgram = [
    "A strategic funding partner embedded with your team",
    "Investor-grade narrative + materials that stand up in real meetings",
    "A clearer path to grants + non-dilutive programs with real preparation",
    "Improved structure & readiness that reduces risk and accelerates timelines",
    "A repeatable fundraising workflow you can keep using",
  ];

  return (
    <>
      {/* ===================== Service Details Area start ===================== */}
      <div className="service-area pd-bottom-90 jumpstart-page">
        <div className="container">
          <div className="row">
            {/* LEFT SIDEBAR */}
            <div className="col-lg-4 col-12 order-2 order-lg-1">
              <div className="td-sidebar service-sidebar">
                <div className="widget widget_catagory">
                                  <h5 className="widget-title" style={{ color: '#50af9b', cursor: 'pointer', transition: 'color 0.3s ease' }} onMouseEnter={(e) => e.target.style.color = '#50af9b'} onMouseLeave={(e) => e.target.style.color = '#50af9b'}>
                                    <FaArrowRight />Funding Program
                                  </h5>
                                  <ul className="catagory-items">
                                    <li><Link to="/funding/jumpstart" onMouseEnter={(e) => e.target.style.color = '#50af9b'} onMouseLeave={(e) => e.target.style.color = '#000000'}>Evolvelab Fund Jumpstart</Link></li>
                                    <li><Link to="/funding/boost" onMouseEnter={(e) => e.target.style.color = '#50af9b'} onMouseLeave={(e) => e.target.style.color = '#000000'}>Evolvelab Fund Boost</Link></li>
                                    <li><Link to="/funding/advisory" onMouseEnter={(e) => e.target.style.color = '#50af9b'} onMouseLeave={(e) => e.target.style.color = '#000000'}>Evolvelab Fund Advisory</Link></li>
                                  </ul>
                
                                  <div style={{ height: '16px' }}></div>
                                  <h5 className="widget-title" style={{ color: '#50af9b', cursor: 'pointer', transition: 'color 0.3s ease' }} onMouseEnter={(e) => e.target.style.color = '#50af9b'} onMouseLeave={(e) => e.target.style.color = '#50af9b'}>
                                    <FaArrowRight />Dev Accelerator
                                  </h5>
                                  <ul className="catagory-items">
                                    <li><Link to="/accelerator/dev-sprint" onMouseEnter={(e) => e.target.style.color = '#50af9b'} onMouseLeave={(e) => e.target.style.color = '#000000'}>Evolvelab Dev Sprint</Link></li>
                                    <li><Link to="/accelerator/dev-build" onMouseEnter={(e) => e.target.style.color = '#50af9b'} onMouseLeave={(e) => e.target.style.color = '#000000'}>Evolvelab Dev Build</Link></li> 
                                    <li><Link to="/accelerator/dev-scale" onMouseEnter={(e) => e.target.style.color = '#50af9b'} onMouseLeave={(e) => e.target.style.color = '#000000'}>Evolvelab Dev Scale</Link></li>
                                  </ul>
                                </div>

                <div className="widget widget_author text-center">
                  
                  <div className="details">
                    <button
                      type="button"
                      className="btn btn-base-color border-radius-5 d-flex align-items-center"
                      style={{ backgroundColor: "#50af9b", borderColor: "#50af9b" }}
                      onClick={() => setShowMeetings((s) => !s)}
                    >
                      Book a Fund Advisory Strategy Call +
                    </button>

                    {showMeetings && (
                      <div className="mt-3">
                        <div
                          className="meetings-iframe-container"
                          data-src="https://meetings.hubspot.com/mike-qureshi?embed=true"
                        ></div>
                      </div>
                    )}
                  </div>
                </div>

                {/* <div className="widget widget_download">
                  <h5
                    className="widget-title"
                    style={{
                      color: "#50af9b",
                      cursor: "pointer",
                      transition: "color 0.3s ease",
                    }}
                    onMouseEnter={(e) => (e.target.style.color = "#50af9b")}
                    onMouseLeave={(e) => (e.target.style.color = "#50af9b")}
                  >
                    <FaArrowRight /> Download
                  </h5>
                  <ul>
                    <li>
                      <a
                        href="/assets/pdf/Evolvelab_Fund_Advisory.pdf"
                        style={{ color: "#000000" }}
                        onMouseEnter={(e) => (e.target.style.color = "#50af9b")}
                        onMouseLeave={(e) => (e.target.style.color = "#000000")}
                      >
                        Download the Program Overview{" "}
                        <FaAngleDoubleRight
                          style={{ background: "rgba(170, 237, 222, 1)" }}
                          onMouseEnter={(e) => (e.target.style.background = "#50af9b")}
                          onMouseLeave={(e) =>
                            (e.target.style.background = "rgba(170, 237, 222, 1)")
                          }
                        />
                      </a>
                    </li>
                  </ul>
                </div> */}

                <div className="widget widget_download">
                  <h5
                    className="widget-title"
                    style={{
                      color: "#50af9b",
                      cursor: "pointer",
                      transition: "color 0.3s ease",
                    }}
                    onMouseEnter={(e) => (e.target.style.color = "#50af9b")}
                    onMouseLeave={(e) => (e.target.style.color = "#50af9b")}
                  >
                    <FaArrowRight /> Fund Advisory Snapshot
                  </h5>
                  <ul>
                    <li>
                      <a
                        href="#pricing"
                        onMouseEnter={(e) => (e.target.style.color = "#50af9b")}
                        onMouseLeave={(e) => (e.target.style.color = "#000000")}
                      >
                        Engagement: Custom / High-Touch
                      </a>
                    </li>
                    <li>
                      <a
                        href="#pricing"
                        onMouseEnter={(e) => (e.target.style.color = "#50af9b")}
                        onMouseLeave={(e) => (e.target.style.color = "#000000")}
                      >
                        Price: Discussed based on scope.
                      </a>
                    </li>
                    <li>
                      <a
                        href="#pricing"
                        onMouseEnter={(e) => (e.target.style.color = "#50af9b")}
                        onMouseLeave={(e) => (e.target.style.color = "#000000")}
                      >
                        Retainer: Discussed based on scope.
                      </a>
                    </li>
                    <li>
                      <a
                        href="#pricing"
                        onMouseEnter={(e) => (e.target.style.color = "#50af9b")}
                        onMouseLeave={(e) => (e.target.style.color = "#000000")}
                      >
                        Model: Strategy + Execution
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* RIGHT CONTENT */}
            <div className="col-lg-8 order-1 order-lg-2">
              <div className="blog-details-page-content">
                <div className="single-blog-inner mb-0">
                  {/* HERO VIDEO */}
                  <div
                    className="thumb"
                    style={{
                      position: "relative",
                      overflow: "hidden",
                      minHeight: "400px",
                      margin: 0,
                    }}
                  >
                    <video
                      autoPlay
                      muted
                      loop
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        zIndex: 0,
                      }}
                    >
                      <source src="/assets/video/advisor.mp4" type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  </div>

                  <div
                    className="details"
                    style={{ position: "relative", zIndex: 1, padding: "50px" }}
                  >
                    {/* HERO COPY */}
                    <p className="mb-2" style={{ fontSize: '1.75rem', fontWeight: 700 }}>Evolvelab Fund Advisory</p>
                    <h1>Custom, Hands-On Capital & Funding Partner</h1>

                    <p className="mb-2">
                      A premium, fully customized, hands-on consulting and execution program for
                      companies that need more than advice.
                    </p>

                    <p>
                      Fund Advisory turns Evolvelab into your strategic partner + implementation team
                      across funding, grants, structure, growth, and investor readiness.
                    </p>

                    <p style={{ marginTop: 10 }}>
                      <b>Reassurance:</b> We’re not a fund or VC. We don’t manage capital — we help you become truly fundable.
                    </p>

                    {/* KEY OUTCOME LIST */}
                    <h5 className="mt-4">With Fund Advisory, you get:</h5>
                    <ul className="single-list-inner style-check style-check mb-4">
                      {outcomes.map((x) => (
                        <li key={x}>
                          <FaCheckCircle style={{ color: "#50af9b" }} /> {x}
                        </li>
                      ))}
                    </ul>

                    {/* PROBLEM */}
                    <h4>You’ve Outgrown Generic Advice</h4>
                    <p>
                      At a certain stage, you don’t need another webinar or a one-off deck review.
                      You need expert hands, not just expert opinions.
                    </p>
                    <ul className="single-list-inner style-check style-check mb-3">
                      {problem.map((x) => (
                        <li key={x}>
                          <FaCheckCircle style={{ color: "#50af9b" }} /> {x}
                        </li>
                      ))}
                    </ul>

                    {/* WHAT IS IT */}
                    <h4>What is Fund Advisory?</h4>
                    <p>
                      Fund Advisory is Evolvelab’s highest-tier engagement. Unlike fixed packages, this is a tailored,
                      done-with-you + done-for-you hybrid built around your business model, sector, stage, goals, and internal capacity.
                    </p>
                    <p><b>We don’t just tell you what to do. We do the work with you.</b></p>

                    {/* WHO IT'S FOR */}
                    <h4>Is Fund Advisory Right for You?</h4>
                    <p>Fund Advisory is ideal if you:</p>
                    <ul className="single-list-inner style-check style-check mb-3">
                      {forWho.map((x) => (
                        <li key={x}>
                          <FaCheckCircle style={{ color: "#50af9b" }} /> {x}
                        </li>
                      ))}
                    </ul>

                    {/* WHAT'S INCLUDED */}
                    <h4>What We Do Together (Strategy + Execution)</h4>
                    <p>
                      Every Fund Advisory engagement is customized, but typically includes:
                    </p>

                    <div className="row">
                      <div className="col-md-6">
                        <ul className="single-list-inner style-check style-check mb-3">
                          {deliverablesLeft.map((x) => (
                            <li key={x}>
                              <FaCheckCircle style={{ color: "#50af9b" }} /> {x}
                            </li>
                          ))}
                        </ul>
                      </div>
                      <div className="col-md-6">
                        <ul className="single-list-inner style-check style-check mb-3">
                          {deliverablesRight.map((x) => (
                            <li key={x}>
                              <FaCheckCircle style={{ color: "#50af9b" }} /> {x}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>

                    {/* OPTIONAL ADD-ONS */}
                    <h4>Optional Deep-Dive Add-Ons</h4>
                    <p>Depending on your needs, Fund Advisory can extend into:</p>
                    <ul className="single-list-inner style-check style-check mb-4">
                      {optionalAddOns.map((x) => (
                        <li key={x}>
                          <FaCheckCircle style={{ color: "#50af9b" }} /> {x}
                        </li>
                      ))}
                    </ul>

                    {/* WHY CHOOSE */}
                    <h4>Why Founders & CEOs Choose This Tier</h4>
                    <ul className="single-list-inner style-check style-check mb-3">
                      {whyChoose.map((x) => (
                        <li key={x}>
                          <FaCheckCircle style={{ color: "#50af9b" }} /> {x}
                        </li>
                      ))}
                    </ul>

                    {/* PRICING */}
                    <h4 id="pricing">How Fund Advisory is Structured</h4>
                    <p>
                      Because this is a bespoke, high-touch service, pricing is based on scope. Typical models:
                    </p>
                    <ul className="single-list-inner style-check style-check mb-3">
                      {engagementModels.map((x) => (
                        <li key={x}>
                          <FaCheckCircle style={{ color: "#50af9b" }} /> {x}
                        </li>
                      ))}
                    </ul>
                    <p><b>Limited advisory slots • Tailored scopes • Pure strategy + execution support</b></p>

                    {/* NOT INCLUDED / CLARITY */}
                    <h4>Clarity & Legal Boundaries</h4>
                    <p>To keep things clear:</p>
                    <ul className="single-list-inner style-check style-check mb-4">
                      {notIncluded.map((x) => (
                        <li key={x}>
                          <FaCheckCircle style={{ color: "#50af9b" }} /> {x}
                        </li>
                      ))}
                    </ul>

                    {/* OUTCOME */}
                    <h4>The Outcome</h4>
                    <p>After Fund Advisory, you will have:</p>
                    <ul className="single-list-inner style-check style-check mb-4">
                      {afterProgram.map((x) => (
                        <li key={x}>
                          <FaCheckCircle style={{ color: "#50af9b" }} /> {x}
                        </li>
                      ))}
                    </ul>

                    {/* FAQ */}
                    <h4>Frequently Asked Questions</h4>
                    <div
                      className="accordion accordion-inner accordion-icon-left mt-3 mb-4"
                      id="accordionExample"
                    >
                      <div className="accordion-item">
                        <h3 className="accordion-header" id="headingOne">
                          <button
                            className="accordion-button"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseOne"
                            aria-expanded="true"
                            aria-controls="collapseOne"
                          >
                            Are you a fund, VC, or financial institution?
                          </button>
                        </h3>
                        <div
                          id="collapseOne"
                          className="accordion-collapse collapse show"
                          aria-labelledby="headingOne"
                          data-bs-parent="#accordionExample"
                        >
                          <div className="accordion-body">
                            No. Evolvelab is not a fund, VC, or financial institution. We do not pool or manage investor money.
                            Fund Advisory is a consulting and execution service focused on strategy, readiness, and implementation.
                          </div>
                        </div>
                      </div>

                      <div className="accordion-item">
                        <h3 className="accordion-header" id="headingTwo">
                          <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseTwo"
                            aria-expanded="false"
                            aria-controls="collapseTwo"
                          >
                            Can you guarantee funding or grant approvals?
                          </button>
                        </h3>
                        <div
                          id="collapseTwo"
                          className="accordion-collapse collapse"
                          aria-labelledby="headingTwo"
                          data-bs-parent="#accordionExample"
                        >
                          <div className="accordion-body">
                            No one can fairly guarantee outcomes. What we can offer is a significant increase in your quality of
                            structure, documents, strategy, and investor readiness, which strongly improves your odds.
                          </div>
                        </div>
                      </div>

                      <div className="accordion-item">
                        <h3 className="accordion-header" id="headingThree">
                          <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseThree"
                            aria-expanded="false"
                            aria-controls="collapseThree"
                          >
                            How is Fund Advisory different from Jumpstart and Boost?
                          </button>
                        </h3>
                        <div
                          id="collapseThree"
                          className="accordion-collapse collapse"
                          aria-labelledby="headingThree"
                          data-bs-parent="#accordionExample"
                        >
                          <div className="accordion-body">
                            Jumpstart is a fixed package for clarity and a roadmap. Boost adds more assets and a structured execution plan.
                            Fund Advisory is fully custom, high-touch consulting + execution for complex or fast-scaling businesses.
                          </div>
                        </div>
                      </div>

                      <div className="accordion-item">
                        <h3 className="accordion-header" id="headingFour">
                          <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseFour"
                            aria-expanded="false"
                            aria-controls="collapseFour"
                          >
                            What do you need from us to start?
                          </button>
                        </h3>
                        <div
                          id="collapseFour"
                          className="accordion-collapse collapse"
                          aria-labelledby="headingFour"
                          data-bs-parent="#accordionExample"
                        >
                          <div className="accordion-body">
                            Founders/leadership engaged in the process, access to your existing materials (deck, financials, corporate docs),
                            and clarity on your main goals (raise, grants, structure, growth, or all of the above).
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* FINAL CTA */}
                    <h4>Ready for a Strategic Partner, Not Just a Consultant?</h4>
                    <p>
                      Fund Advisory is for leaders who want a true capital and funding partner — someone in the trenches with them,
                      helping design, build, and execute the work that makes funding possible.
                    </p>

                    <div className="d-flex flex-wrap gap-2 mt-3">
                      <button
                        type="button"
                        className="btn btn-base-color border-radius-5"
                        style={{ backgroundColor: "#50af9b", borderColor: "#50af9b" }}
                        onClick={() => setShowMeetings((s) => !s)}
                      >
                        📅 Book a Fund Advisory Strategy Call
                      </button>

                      <Link className="btn btn-black border-radius-5" to="/apply">
                        🧾 Request a Custom Proposal
                      </Link>
                    </div>

                    {showMeetings && (
                      <div className="mt-4">
                        <div
                          className="meetings-iframe-container"
                          data-src="https://meetings.hubspot.com/mike-qureshi?embed=true"
                        ></div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      {/* ===================== Service Details Area End ===================== */}
    </>
  );
};

export default AdvisoryArea;